import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink, UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

import { isInternalURL } from '@plone/volto/helpers/Url/Url';

const ServiceTemplate = ({ items, linkTitle, linkHref, isEditMode }) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <UniversalLink href={href}>{linkTitle || href}</UniversalLink>;
  }

  return (
    <>
      <div className="items-service">
        {items.map((item) => (
          <div className="listing-item-service" key={item['@id']}>
            <div className="listing-icon-service">
              <i className={'fa ' + item.icon} style={{ fontSize: 30, color: '#0076D6' }}></i>
            </div>
            <ConditionalLink item={item} condition={!isEditMode}>
              <div className="listing-body-service">
                <p className="listing-title-service">{item.title ? item.title : item.id}</p>
                <p className="listing-sub-service">{item.description}</p>
              </div>
            </ConditionalLink>
          </div>
        ))}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};
ServiceTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};
export default ServiceTemplate;
